<template>
<div id="page-templates" >
    <div>
        <v-breadcrumbs :items="breadcrumbs" >
            <v-icon slot="divider" >forward</v-icon>
        </v-breadcrumbs>
    </div>
    <v-container fluid fill-height>
        <v-layout align-center justify-center>
            <v-flex xs12>
                <base-material-card color="primary" icon="library_books" title="PDF en Módulos" class="elevation-1 px-5 py-3" >

                    <v-card-text>
                        <v-card class="elevation-1 px-5 py-3" >
                            <h5>Datos Generales - Sellos Digitales</h5>
                            <v-card-text>
                                <v-form ref="form" lazy-validation>
                                    <v-container grid-list-md>
                                        <v-layout wrap>

                                            <v-flex xs12>
                                                <v-text-field label="Manual de recuperación WS" @click='pickFile("a1")' v-model='file_a_1' :readonly="true" prepend-icon='attach_file'></v-text-field>
                                                <input type="file" style="display: none" ref="a1" accept=".pdf" @change="onFilePicked" >
                                                <!-- RecuperarFirmaVUCEM.pdf -->
                                            </v-flex>
                                            <v-flex xs12>
                                                <v-text-field label="Manual de creación de Sellos VUCEM" @click='pickFile("a2")' v-model='file_a_2' :readonly="true" prepend-icon='attach_file'></v-text-field>
                                                <input type="file" style="display: none" ref="a2" accept=".pdf" @change="onFilePicked" >
                                                <!-- CrearSellosVUCEM.pdf -->
                                                
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-form>
                            </v-card-text>
                        </v-card>
                        <v-card class="elevation-1 px-5 py-3" >
                            <h5>VUCEM Transmisión</h5>
                            <v-card-text>
                                <v-form ref="form" lazy-validation>
                                    <v-container grid-list-md>
                                        <v-layout wrap>

                                            <v-flex xs12>
                                                <v-text-field label="Diccionario de COVE" @click='pickFile("b1")' v-model='file_b_1' :readonly="true" prepend-icon='attach_file'></v-text-field>
                                                <input type="file" style="display: none" ref="b1" accept=".pdf" @change="onFilePicked" >
                                                <!-- COVE_DiccionarioDeDatos.pdf -->
                                            </v-flex>
                                            <v-flex xs12>
                                                <v-text-field label="Manifestación de Valor Electrónica" @click='pickFile("b2")' v-model='file_b_2' :readonly="true" prepend-icon='attach_file'></v-text-field>
                                                <input type="file" style="display: none" ref="b2" accept=".pdf" @change="onFilePicked" >
                                                <!-- ManifestacionValor.pdf -->
                                            </v-flex>
                                        </v-layout>
                                    </v-container>
                                </v-form>
                            </v-card-text>
                        </v-card>
                        <v-card class="elevation-1 px-5 py-3" >
                            <h5>Data Stage</h5>
                            <v-card-text>
                                <v-form ref="form" lazy-validation>
                                    <v-container grid-list-md>
                                        <v-layout wrap>

                                            <v-flex xs12>
                                                <v-text-field label="Manual de Consulta" @click='pickFile("c1")' v-model='file_c_1' :readonly="true" prepend-icon='attach_file'></v-text-field>
                                                <input type="file" style="display: none" ref="c1" accept=".pdf" @change="onFilePicked" >
                                                <!-- ManualConsultaDataStage.pdf -->
                                            </v-flex>

                                        </v-layout>
                                    </v-container>
                                </v-form>
                            </v-card-text>
                        </v-card>
                        <v-card class="elevation-1 px-5 py-3" >
                            <h5>VUCEM Pedimento</h5>
                            <v-card-text>
                                <v-form ref="form" lazy-validation>
                                    <v-container grid-list-md>
                                        <v-layout wrap>

                                            <v-flex xs12>
                                                <v-text-field label="Manual de Consulta WS" @click='pickFile("d1")' v-model='file_d_1' :readonly="true" prepend-icon='attach_file'></v-text-field>
                                                <input type="file" style="display: none" ref="d1" accept=".pdf" @change="onFilePicked" >
                                                <!-- ManualConsultaDiccionarioPedimento.pdf-->
                                            </v-flex>

                                        </v-layout>
                                    </v-container>
                                </v-form>
                            </v-card-text>
                        </v-card>
                        <v-card class="elevation-1 px-5 py-3" >
                            <h5>TIGIE</h5>
                            <v-card-text>
                                <v-form ref="form" lazy-validation>
                                    <v-container grid-list-md>
                                        <v-layout wrap>

                                            <v-flex xs12>
                                                <v-text-field label="NICOs y su Correlación" @click='pickFile("e1")' v-model='file_d_1' :readonly="true" prepend-icon='attach_file'></v-text-field>
                                                <input type="file" style="display: none" ref="e1" accept=".pdf" @change="onFilePicked" >
                                                <!-- DOF_DGCE_NICO17_NOV_2020.pdf-->
                                            </v-flex>

                                            <v-flex xs12>
                                                <v-text-field label="Acuerdo de Metodología, para creación y modificación de NICOs" @click='pickFile("e2")' v-model='file_d_1' :readonly="true" prepend-icon='attach_file'></v-text-field>
                                                <input type="file" style="display: none" ref="e2" accept=".pdf" @change="onFilePicked" >
                                                <!-- acuerdo_metodologia.pdf-->
                                            </v-flex>

                                        </v-layout>
                                    </v-container>
                                </v-form>
                            </v-card-text>
                        </v-card>
                        <v-card class="elevation-1 px-5 py-3" >
                            <h5>Solución A31</h5>
                            <v-card-text>
                                <v-form ref="form" lazy-validation>
                                    <v-container grid-list-md>
                                        <v-layout wrap>

                                            <v-flex xs12>
                                                <v-text-field label="Manual Técnico Archivos TXT" @click='pickFile("sa1")' v-model='file_d_1' :readonly="true" prepend-icon='attach_file'></v-text-field>
                                                <input type="file" style="display: none" ref="sa1" accept=".pdf" @change="onFilePicked" >
                                                <!-- DOF_DGCE_NICO17_NOV_2020.pdf-->
                                            </v-flex>

                                            <v-flex xs12>
                                                <v-text-field label="Manual Operación Inventario Inicial" @click='pickFile("sa2")' v-model='file_d_1' :readonly="true" prepend-icon='attach_file'></v-text-field>
                                                <input type="file" style="display: none" ref="sa2" accept=".pdf" @change="onFilePicked" >
                                                <!-- acuerdo_metodologia.pdf-->
                                            </v-flex>

                                        </v-layout>
                                    </v-container>
                                </v-form>
                            </v-card-text>
                        </v-card>
                    </v-card-text>
                </base-material-card>
            </v-flex>
        </v-layout>
    </v-container>
</div>
</template>

<script>
import axios from "axios";

export default {
    created: function () {

    },
    data() {
        return {
            fab: false,

            file_a_1: "",
            file_a_2: "",
            file_b_1: "",
            file_b_2: "",
            file_c_1: "",
            file_d_1: "",
            file_e_1: "",
            file_e_2: "",

            show_loading: true,

            breadcrumbs: [{
                    text: "Administración",
                    disabled: false,
                    to: "/admin"
                },
                {
                    text: "PDF en Módulos",
                    disabled: true,
                    href: ""
                }
            ],
            selected: "",
            title: "",
            modal: false,
            update: false,
            estados: [],
            size_file: 0,
            type_file: 'application/pdf',
            rules: {
                required: v => !!v || "Este campo es requerido",
            },

        };
    },

    methods: {
        pickFile(id) {
            if (id == 'a1'){
                this.selected='RecuperarFirmaVUCEM.pdf'; 
                this.$refs.a1.click();
            } 
            if (id == 'a2') {
                this.selected='CrearSellosVUCEM.pdf'; 
                this.$refs.a2.click();
            }
            if (id == 'b1') {
                this.selected='COVE_DiccionarioDeDatos.pdf'; 
                this.$refs.b1.click();
            }
            if (id == 'b2') {
                this.selected='ManifestacionValor.pdf'; 
                this.$refs.b2.click();
            }
            if (id == 'c1')
            { 
                this.selected='ManualConsultaDataStage.pdf'; 
                this.$refs.c1.click();
            }
            if (id == 'd1') {
                this.selected='ManualConsultaDiccionarioPedimento.pdf'; 
                this.$refs.d1.click();
            }
            if (id == 'e1') 
            {
                this.selected='DOF_DGCE_NICO17_NOV_2020.pdf'; 
                this.$refs.e1.click();
            }
            if (id == 'e2') 
            {
                this.selected='acuerdo_metodologia.pdf';
                this.$refs.e2.click();
            }
            if (id == 'sa1') 
            {
                this.selected='ManualTecnicoArchviosTXT.pdf'; 
                this.$refs.e1.click();
            }
            if (id == 'sa2') 
            {
                this.selected='ManualOperacionInventarioInicial.pdf';
                this.$refs.e2.click();
            }
        },
        onFilePicked(e) {
            try {
                const files = e.target.files;
                if (files[0] !== undefined) {

                    this.name_file = files[0].name;
                    this.size_file = files[0].size;
                    this.type_file = files[0].type;

                    if (this.size_file > 1000 * 1000 * 10) {
                        this.$swal({
                            type: "warning",
                            title: "¡Operación no Permitida!",
                            text: "El archivo no debe ser mayor a 10MB.",
                        });
                        this.reset();
                        return false;
                    }
                   // console.log(this.selected);
                   this.uploadFile(files[0], this.selected);
                }
            } catch (error) {
                console.log(error);
                this.$swal({
                    type: "error",
                    title: "¡Operación no Permitida!",
                    text: "Ocurrió un error al leer el archivo. Favor de verificar que el archivo no esté dañado.",
                    footer: ""
                });
                this.$root.$dialogLoader.hide();
                this.reset();
            }

        },

        uploadFile: function (file, referencia) {
            this.$root.$dialogLoader.show('ESPERE UN MOMENTO POR FAVOR..');

            var thisObj = this;

            var keyFile = referencia;

            var datos = {
                key: keyFile,
                bucket: "descargas.econnectpro.mx",
                type: thisObj.type_file
            }
            axios.post(thisObj.$hostname + 's3/upload_url/', datos)
                .then((res) => {
                    if (typeof res.data !== 'undefined') {
                        var urlput = res.data.mensaje;
                        //console.log(urlput);
                        axios.put(urlput, file, {
                                headers: {
                                    'Content-Type': thisObj.type_file
                                }
                            })
                            .then((res) => {
                                thisObj.$root.$dialogLoader.hide();
                                thisObj.$swal({
                                    type: "success",
                                    title: "¡Operación Exitosa!",
                                    text: "El archivo se actualizó correctamente",
                                    footer: '',
                                });
                            })
                            .catch((error) => {
                                thisObj.$root.$dialogLoader.hide();
                                thisObj.$swal({
                                    type: "error",
                                    title: "¡Operación no Permitida!",
                                    text: "Ocurrió un erro al cargar el archivo. Intente nuevamente por favor.",
                                    footer: '',
                                });
                                console.log(error);
                            });

                    } else {
                        thisObj.$swal({
                            type: "error",
                            title: "¡Operación no Permitida!",
                            text: "Ocurrió un erro al cargar el archivo. Intente nuevamente por favor.",
                            footer: '',
                        });
                    }
                })
                .catch((error) => {
                    var mensaje = "Ocurrió un error al cargar el archivo. Intente nuevamente por favor.";
                    if (error.response != undefined && error.response.data != undefined && error.response.data.mensaje != undefined)
                        mensaje = error.response.data.mensaje;
                    thisObj.$swal({
                        type: "error",
                        title: "¡Operación no Permitida!",
                        text: mensaje,
                        footer: '',
                    });
                    console.log(error);
                    thisObj.$root.$dialogLoader.hide();
                });

        },

    }
};
</script>
